import { arrayOf, shape, string } from 'prop-types'
import styled from 'styled-components'
import { Link } from '../Ui-Kits/Text/Link'

export const Breadcrumb = ({ links, ...props }) => {
  return (
    <Wrap {...props}>
      {links.map(({ link, label }, index, list) => (
        <BreadcrunbItem key={index}>
          <Link
            color="black"
            to={link}
            bold
            underline={index !== list.length - 1}
            as={list.length === index + 1 ? 'span' : undefined}
          >
            {label}
          </Link>
        </BreadcrunbItem>
      ))}
    </Wrap>
  )
}
const Wrap = styled.ul`
  list-style: none;
  max-width: 1200px;
  width: 100%;
  margin: 40px auto 80px;
`

const BreadcrunbItem = styled.li`
  display: inline;
  margin: 0;
  &:after {
    display: inline;
    color: var(--color-black);
    content: ' / ';
  }
  &:last-child:after {
    display: none;
  }
`

Breadcrumb.propTypes = {
  links: arrayOf(
    shape({
      link: string,
      label: string,
    })
  ),
}
